var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-filter-advanced-group',{attrs:{"title":"Subset","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a game's name to add...","field":"name","filter":_vm.value('games/subset'),"api":"games/suggest","data":"games"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }